/** The outcome of one check for one entity. @public */
export type CheckOutcome = "pass" | "fail" | "noData";

/**
 * Only `true` passes and only `false` fails; anything else (a missing,
 * `null` or non-boolean result) is no data. Never throws.
 * @public
 */
export function checkOutcome(value: unknown): CheckOutcome {
  if (value === true) return "pass";
  if (value === false) return "fail";
  return "noData";
}
